import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate32.scss';

import React from 'react';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';
import { cn } from '../../../utils/bem';
import { IMG_WIDTH, IRoot32 } from './models/CTI_32.props';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Picture } from '@dataartdev/uikit/Picture';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { useSelector } from 'react-redux';
import { screenSelector } from '../../../../store';
import { Tooltip } from 'react-tooltip';

const cnPictureHints = cn('PictureHints');

export const ContentBuilderTemplate: React.FC<IRoot32> = props => {
  const {
    type,
    title,
    picture,
    contentId,
    position,
    tooltips = [],
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type?.toString();

  const picFullWidth = position.name === IMG_WIDTH.FULL;
  const desktopCol = position.name === IMG_WIDTH.CONTAINER_WIDTH ? 8 : 12;

  const { isMobile } = useSelector(screenSelector);

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <div className={cnPictureHints()}>
        <Grid
          breakpoints={{
            desktop: { cols: 12, gap: 'xl' },
            tablet: { cols: 12, gap: 'xl' },
            mobile: { cols: 12, gap: 'xl' },
          }}
        >
          {title && (
            <GridItem
              breakpoints={{
                desktop: { col: desktopCol },
                tablet: { col: 12 },
                mobile: { col: 12 },
              }}
            >
              <Typography.Title size="lg" as="h2">
                {title}
              </Typography.Title>
            </GridItem>
          )}
          <GridItem
            breakpoints={{
              desktop: { col: desktopCol },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
            className={cnPictureHints('Picture', {
              picFullWidth: picFullWidth,
            })}
          >
            <div className={cnPictureHints('Tooltips')}>
              {tooltips.length > 0 &&
                tooltips.map(tooltip => {
                  const { id, text, yAxis = 0, xAxis = 0 } = tooltip || {};
                  if (!text) return null;
                  return (
                    <div
                      key={id}
                      className={cnPictureHints('Tooltip')}
                      style={{
                        left: `${xAxis}%`,
                        top: `${yAxis}%`,
                      }}
                    >
                      <div
                        className={cnPictureHints('Tooltip-Trigger')}
                        data-tooltip-id={id}
                        data-tooltip-html={text}
                      />
                      <Tooltip
                        id={id}
                        openOnClick={isMobile}
                        className={cnPictureHints('Tooltip-Inner')}
                      />
                    </div>
                  );
                })}
            </div>
            {picture && <Picture {...picture} />}
          </GridItem>
        </Grid>
      </div>
    </div>
  );
};

export default ContentBuilderTemplate;
